function updateResizeInside(root) {
  const container = root.querySelector('.container');
  const movable = root.querySelector('.container-slider-wrapper');

  if (!container || !movable) return;

  const rect = container.getBoundingClientRect();
  root.style.setProperty('--inside-offset', `${Math.max(rect.left, 0)}px`);
}

function initResizeInside() {
  const blocks = document.querySelectorAll('.resize-inside');

  const observer = new ResizeObserver(() => {
    blocks.forEach(updateResizeInside);
  });

  blocks.forEach((block) => {
    const container = block.querySelector('.container');
    if (!container) return;

    updateResizeInside(block);
    observer.observe(container);
  });

  window.addEventListener('resize', () => {
    blocks.forEach(updateResizeInside);
  });
}

initResizeInside();